import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Injectable, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatTreeModule } from '@angular/material/tree';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { QuillModule } from 'ngx-quill';
import { FragmentsModule } from 'src/app/fragments/fragments.module';
import { AuthGuard } from 'src/app/services/auth/auth.guard';
import { ContactComponent } from '../contact/contact.component';
import { CourriersRelevesComponent } from './courriers-releves/courriers-releves.component';
import { ConnectToApicryptComponent } from './inbox/connect-to-apicrypt/connect-to-apicrypt.component';
import { ConnectToMailizComponent } from './inbox/connect-to-mailiz/connect-to-mailiz.component';
import { MssCreateFolderComponent } from './inbox/mss-create-folder/mss-create-folder.component';
import { MssMessageDisplayComponent } from './inbox/mss-message-display/mss-message-display.component';
import { MssRecipientSearchComponent } from './inbox/mss-recipient-search/mss-recipient-search.component';
import { MssComponent } from './inbox/mss.component';
import { PresendClinicalDocumentModalComponent } from './inbox/presend-clinicaldocument-modal/presend-clinicaldocument-modal.component';
import { SelectAccountModalComponent } from './inbox/select-account-modal/select-account-modal.component';
import { MSSMenuComponent } from './mss-menu.component';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { RelevageApicryptComponent } from './inbox/relevage-apicrypt/relevage-apicrypt.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';

@Injectable()
export class MatPaginatorIntlFR extends MatPaginatorIntl {
  itemsPerPageLabel = 'Messages par page';
  nextPageLabel     = 'Page Suivante';
  previousPageLabel = 'Page Précédente';
}

@NgModule({
  declarations: [
    CourriersRelevesComponent,
    MSSMenuComponent,
    MssComponent,
    MssCreateFolderComponent,
    MssMessageDisplayComponent,
    MssRecipientSearchComponent,
    ContactComponent,
    SelectAccountModalComponent,
    PresendClinicalDocumentModalComponent,
    ConnectToMailizComponent,
    ConnectToApicryptComponent,
    RelevageApicryptComponent,
  ],
  exports: [
    // On exporte ces composants pour qu'ils soient accessibles depuis le module user-root.module.ts
    PresendClinicalDocumentModalComponent,
    ConnectToMailizComponent,
    ConnectToApicryptComponent,
    RelevageApicryptComponent,
  ],
  imports: [
    CommonModule,
    FragmentsModule,
    FormsModule,
    ReactiveFormsModule,
    MatTreeModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatCheckboxModule,
    NgxPaginationModule,
    MatSlideToggleModule,
    DragDropModule,
    RouterModule.forChild([
      {
        path: '',
        component: MSSMenuComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'releves',
            component: CourriersRelevesComponent
          },
          {
            path: 'inbox',
            component: MssComponent
          },
        ]
      }
    ]),
    QuillModule.forRoot(),
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot()
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: MatPaginatorIntlFR
    }
  ]
})
export class MssMenuRootModule { }
